<template>
    <form-input
        class="number-input"
        :placeholder="placeholder"
        :label="label"
        :required="required"
        :description="description"
        :name="name"
        :disabled="disabled"
        :value="dispVal"
        :imask="{
            mask: '000{-}000{-}0000{ }********************'
        }"
        :trim="true"
        @input="onNumberInput"
        @change="onNumberChange"
        @keydown="onKeydown"
        @focus="onFocus"
        @blur="onBlur"
    />
</template>

<script>
    import FormControl from '../mixins/FormControl.vue';

    export default {
        name: 'FormLength',
        data() {
            return {
                regex: /^\d{3}-\d{3}-\d{4}/,
                dispVal: this.value,
                ignoreVal: false
            };
        },
        mixins: [FormControl],
        props: {
            placeholder: {
                type: String,
                default: ''
            }
        },
        methods: {
            onNumberInput(val) {
                // Only emit the value if it is a complete phone number
                if (!this.regex.test(val)) {
                    this.dispVal = val;
                    this.ignoreVal = true;
                    val = '';
                }
                this.$emit('input', val);
            },
            onNumberChange(val) {
                // Only emit the value if it is a complete phone number
                if (!this.regex.test(val)) {
                    val = '';
                }
                this.$emit('change', val);
            }
        },
        watch: {
            value(val) {
                if (!this.ignoreVal || val !== '') {
                    this.dispVal = val;
                }
                this.ignoreVal = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>